import { render, staticRenderFns } from "./zeroSales.vue?vue&type=template&id=267a1d39&scoped=true"
import script from "./zeroSales.vue?vue&type=script&lang=js"
export * from "./zeroSales.vue?vue&type=script&lang=js"
import style0 from "./zeroSales.vue?vue&type=style&index=0&id=267a1d39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267a1d39",
  null
  
)

export default component.exports